// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function createLocalAction(actionType) {
    return (payload = {}) => ({
        type: actionType,
        payload: payload,
    });
}
